var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* eslint-disable @typescript-eslint/no-explicit-any */
import Styles from './input-kv-styles.scss';
import React, { useRef } from 'react';
import classNames from 'classnames';
import MaskedInput from 'react-maskedinput';
import SpanRequired from '../span-required/span-required';
import { isMobile, isTablet } from 'mobile-device-detect';
const getClassNameList = (error, leftIcon, rightIcon) => {
    const list = [];
    if (error)
        list.push(Styles.inputError);
    if (leftIcon && rightIcon) {
        list.push(Styles.overWriteBoth);
    }
    else {
        if (leftIcon)
            list.push(Styles.overWriteLeft);
        if (rightIcon)
            list.push(Styles.overWriteRight);
    }
    return classNames(list);
};
const isMobileOrTablet = isMobile || isTablet;
const InputKVBase = (_a) => {
    var { state, setState, leftIcon, rightIcon, readOnly = !isMobileOrTablet, isIconBtn = false, hardReadOnly = false, hideRequiredDot = false, mask, initialValue, inputWrapClass } = _a, props = __rest(_a, ["state", "setState", "leftIcon", "rightIcon", "readOnly", "isIconBtn", "hardReadOnly", "hideRequiredDot", "mask", "initialValue", "inputWrapClass"]);
    // console.log("🚀 ~ file: input-kv.tsx:153 ~ state:", state);
    const inputRef = useRef();
    const error = state[`${props.name}Error`];
    const isFormDirty = state.dirtyFields ? state.dirtyFields[props.name] : true;
    const changeValue = (e) => {
        e.preventDefault();
        const value = e.target.value;
        setState(Object.assign(Object.assign({}, state), { [e.target.name]: e.target.value, dirtyFields: Object.assign(Object.assign({}, state.dirtyFields), { [e.target.name]: true }) }));
        if (props.maxcharacters > 0 && value.length > props.maxcharacters) {
            inputRef.current.value = value.slice(0, -1);
        }
    };
    const LabelInput = () => {
        return (React.createElement("label", { className: props.label ? Styles.labelInput : Styles.labelPlaceholder, "data-testid": `${props.name}-label`, onClick: () => {
                if (!props.label)
                    inputRef.current.focus();
            }, title: error },
            props.label ? props.label : props.placeholder,
            " ",
            props.required && !hideRequiredDot && React.createElement(SpanRequired, null)));
    };
    const isDateInput = props.type === 'date';
    return (React.createElement("div", { "data-testid": `${props.name}-wrap`, className: classNames(Styles.inputWrap, inputWrapClass), "data-status": error && isFormDirty ? 'invalid' : 'valid' },
        React.createElement(LabelInput, null),
        leftIcon && React.createElement("div", { className: Styles.leftIconWrap }, leftIcon),
        mask && (React.createElement(MaskedInput, Object.assign({}, props, { ref: inputRef, title: error, value: state[props.name], placeholder: props.placeholder, "data-testid": props.name, readOnly: true, mask: mask, placeholderChar: "_", onFocus: e => {
                e.target.readOnly = false;
            }, onChange: e => {
                setState(Object.assign(Object.assign({}, state), { [e.target.name]: e.target.value, dirtyFields: Object.assign(Object.assign({}, state.dirtyFields), { [e.target.name]: true }) }));
            }, className: getClassNameList(error ? isFormDirty : '', leftIcon, rightIcon) }))),
        !mask && (React.createElement("input", Object.assign({}, props, { ref: inputRef, title: error, value: initialValue !== null && initialValue !== void 0 ? initialValue : state[props.name], placeholder: props.label ? props.placeholder : ' ', "data-testid": props.name, readOnly: isDateInput ? undefined : readOnly, onFocus: e => {
                if (!hardReadOnly && !isMobileOrTablet && !isDateInput)
                    e.target.readOnly = false;
            }, onChange: e => {
                changeValue(e);
            }, className: getClassNameList(error ? isFormDirty : '', leftIcon, rightIcon) }))),
        rightIcon && (React.createElement("div", { className: classNames({
                [Styles.rightIconWrap]: !isIconBtn,
                [Styles.rightIconButtonWrap]: isIconBtn
            }) }, rightIcon)),
        error && isFormDirty && (React.createElement("span", { "data-testid": `${props.name}-error-label`, className: Styles.spanError }, error))));
};
export default InputKVBase;
